







































import Vue from 'vue'
import { Component, Watch, Prop, Emit } from 'vue-property-decorator'
import AppDialog from '@/components/AppDialog.vue'
import { showErrors } from '@/utils/snack'
import { getDocusignTemplates } from '@/modules/Envelop/gql/envelop.gql'
import { getRelatedAcordForms } from '@/modules/Envelop/gql/acordForms.gql'
import AppRadio from '@/components/AppRadio.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { docusignDocumentTypeValues } from '@/modules/Envelop/helpers/envelop-detail'
@Component({
  components: {
    AppDialog,
    AppRadio,
    AppTextSearch
  }
})
export default class AddFileDialog extends Vue {
  @Prop({ type: Boolean }) readonly value!: boolean;
  addFileDialog = {
    show: false
  };
  options = docusignDocumentTypeValues;
  selectedIndex = 0;
  addFileForm: {
    [key: string]: any;
  } = {};
  templates = [];
  acordForms = [];
  templateTypes = [];
  acordFormTypes = [];

  @Watch('value')
  onShowChanged (val: boolean) {
    this.addFileDialog.show = val
  }

  @Watch('selectedIndex')
  selectHandle (val: number) {
    (this.$refs.form as Vue & { reset: () => void }).reset()
  }

  @Emit('hide')
  onHide () {
    this.addFileDialog.show = false
    this.resetForm()
  }

  @Emit('confirm')
  confirm () {
    this.onHide()
    return this.addFileForm
  }

  async mounted () {
    await this.getAcordForm()
    await this.getTemplates()
    this.templates = this.templateTypes
    this.acordForms = this.acordFormTypes
  }

  get templateOptions () {
    return this.templates.map((item: any) => {
      return {
        name: item.name,
        id: item.id
      }
    })
  }

  get acordFormOptions () {
    return this.acordForms.map((item: any) => {
      return {
        id: item.id,
        name: item.name
      }
    })
  }

  async getTemplates () {
    const result = await this.$apollo.query({
      query: getDocusignTemplates,
      variables: {
        paging: {},
        filter: {
          name: ''
        }
      }
    })
    this.templateTypes = result.data.getDocusignTemplates.templates
  }

  async getAcordForm () {
    const { masterId, masterType } = this.$route.params
    try {
      const result = await this.$apollo.query({
        query: getRelatedAcordForms,
        variables: {
          masterId: +masterId,
          masterType: masterType.toUpperCase()
        }
      })
      this.acordFormTypes = result.data.getRelatedAcordForms
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 查询
  getQuery (val: string) {
    if (this.selectedIndex === 0) {
      // 查询模板
      if (val) {
        this.templates = this.templateTypes.filter(
          (item: any) =>
            item.name &&
            item.name
              .toString()
              .toLowerCase()
              .indexOf(val && val.toString().toLowerCase()) !== -1
        )
      } else {
        this.templates = this.templateTypes
      }
    } else {
      // 查询acord
      if (val) {
        this.acordForms = this.acordFormTypes.filter(
          (item: any) =>
            item.name &&
            item.name
              .toString()
              .toLowerCase()
              .indexOf(val && val.toString().toLowerCase()) !== -1
        )
      } else {
        this.acordForms = this.acordFormTypes
      }
    }
  }
  // dialog确认
  async addFileConfirm () {
    if (this.validateForm()) {
      this.onHide()
    } else {
      return false
    }
  }
  // 选择事件
  selectHandler (val: any) {
    this.addFileForm.type = this.options[this.selectedIndex]
  }
  // 取消
  cancel () {
    this.onHide()
  }
  // 重置表单
  resetForm () {
    (this.$refs.form as Vue & { reset: () => void }).reset()
    this.selectedIndex = 0
  }
  // 表单验证
  validateForm () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
